import { createContext, useContext, useState } from 'react';

import {
  NotificationContextProviderProps,
  NotificationContextType
} from '../types/notificationTypes';

const NotificationContext = createContext<NotificationContextType | null>(null);

export const NotificationProvider = ({
  children
}: NotificationContextProviderProps) => {
  const [openNotifications, setOpenNotifications] = useState(false);
  const [notificationsFiltered, setNotificationsFiltered] = useState([]);

  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState(new Set());

  const [status, setStatus] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(5);
  const [unreadNotificationsTotal, setUnreadNotificationsTotal] =
    useState<number>(0);

  const offset = (currentPage - 1) * itemsPerPage + 1;

  const resetCheckboxes = () => {
    setSelectAll(false);
  };

  const toggleNotifications = () => {
    setOpenNotifications(!openNotifications);
  };

  return (
    <NotificationContext.Provider
      value={{
        toggleNotifications,
        openNotifications,
        notificationsFiltered,
        setNotificationsFiltered,
        selectAll,
        setSelectAll,
        selectedItems,
        setSelectedItems,
        resetCheckboxes,
        status,
        setStatus,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        setItemsPerPage,
        unreadNotificationsTotal,
        setUnreadNotificationsTotal,
        offset
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);

  return context;
};
